// Who sees how much of the sidebar's Field service group (PRD 88 §4.1) — the
// one rule, so a later row (Service locations, PRD 88 Wave 2) and the group
// itself cannot disagree about a business.

import type { BusinessModulesState, ModuleNavAccess } from '../../services/businessModulesStore';
import { FIELD_SERVICE_RELEASED } from './release';

/**
 * The sidebar's answer for the Field service group.
 *
 *   - Unknown draws nothing: an unreleased paid module is never guessed into
 *     anybody's menu (businessModulesStore).
 *   - A holder sees every row — today, design partners on an admin grant.
 *   - WHILE UNRELEASED, nobody else sees a row at all: web merges deploy prod,
 *     and a business without the grant must find no trace of the module.
 *   - After release, a business that set it up and then lapsed keeps every row,
 *     read-only (PRD 42 Rule 4), and one that never set it up sees one row,
 *     the Overview, whose page carries the banner — not the CRM pattern's
 *     sidebar full of upsell pages. An unknown set-up still draws that one row,
 *     since both answers draw it.
 */
export function fieldServiceNavAccess(state: BusinessModulesState): ModuleNavAccess {
  if (!state.modules) return 'none';
  if (state.modules.field_service === true) return 'all';
  if (!FIELD_SERVICE_RELEASED) return 'none';
  if (state.fieldServiceSetUp === true) return 'all';
  return 'front_door';
}
